module.exports = __webpack_public_path__ + "static/ancient-blue-dragon-5f02b7d1d361783e2a788e1c85e74ac5.png";